// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/chunk-" + {"10":"a9da995c519320b8","224":"5267df44ae02ad2a","768":"b3e10973be8b82ef","843":"87e7b4b78ae1b4a9"}[chunkId] + ".css";
};